import { IChoiceItem } from './ChoiceItem';
import { IActionsProps } from '../ButtonPanel/ButtonPanel';


export function convertChoicesToButtons(
  choices: IChoiceItem[],
  onChoose: (item: IChoiceItem) => void
): IActionsProps[] {
  return choices.map(item => {
    return {...convertChoiceToButton(item, onChoose), position: 'left'}
  });
}

export function convertChoiceToButton(choice: IChoiceItem, onChoose: (item: IChoiceItem) => void): IActionsProps {
  return {
    id: choice.id,
    onClick: () => onChoose(choice),
    name: choice.asButtonText ?? choice.title,    
  };
}

export function getSideBarPosition(choice: IChoiceItem, choices: IChoiceItem[]) {
  const index = choices.indexOf(choice);
  switch (choices.length) {
    case 3:
      return index < 2 ? 'right' : 'left';
    case 2:
      return index === 0 ? 'right' : 'left';
    default:
      return 'right';
  }
}
